import React from "react";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { Query } from "../interfaces";

interface Props {
  resetState: (state: Query) => void;
  buttonLabel?: string;
  updateFormField?: string;
}

function BackToResultsButton({
  resetState,
  buttonLabel,
  updateFormField,
}: Props) {
  const location = useLocation();
  const navigate = useNavigate();
  const prevState = location.state?.prevAppState as Query;
  const prevPath = location.state?.prevPath as string;
  if (!prevState || !prevPath) {
    return null;
  }

  function backButton() {
    if (prevState) {
      if (updateFormField) {
        prevState.ui = { ...prevState.ui, updateFormField };
      }

      resetState(prevState);
    }

    if (prevPath) {
      navigate(prevPath);
    } else {
      navigate("/");
    }
  }
  return (
    <Button variant="contained" color="secondary" onClick={backButton}>
      {buttonLabel ?? "Back to Results"}
    </Button>
  );
}

export default BackToResultsButton;
